import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-requisition-products',
    templateUrl: './requisition-products.component.html',
    styleUrls: ['./requisition-products.component.scss']
})
export class RequisitionProductsComponent implements OnInit {
    @Input() requisition: any = [];

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/requisition-products/requisition-products.component.ts